import {KilnMaterialInstallation} from '@refra/modules/refra-planning/types'

export const materialAtMeter = (
  materialInstallations: KilnMaterialInstallation[] | undefined,
  meter: number | undefined
) => {
  if (meter === undefined || materialInstallations === undefined) return undefined

  return materialInstallations.find(
    (material) => meter >= material.fromMeter && meter <= material.toMeter
  )
}
